export interface DictionaryParameterEntity {
  id: number;
  name: string;
  validFrom: Date;
  validTo: Date;
  value: number;
}
